import { getUserInfo } from '@/apis/personal'
import { useUserStore } from '@/stores/user'
import { mergeUserInfo } from './userInfoMerge.mjs'

export async function refreshStoredUserInfo() {
  const userStore = useUserStore()
  const res = await getUserInfo()

  if (res.code === 200 && res.data) {
    const mergedUserInfo = mergeUserInfo(userStore.userInfo, res.data)
    userStore.setUserInfo(mergedUserInfo)
    return mergedUserInfo
  }

  return null
}
